/*
 * @Author: gongzhichao 18311120024@163.com
 * @Date: 2023-05-25 19:05:44
 * @LastEditors: gongzhichao 18311120024@163.com
 * @LastEditTime: 2024-03-19 17:44:38
 * @FilePath: \jyrg-web\src\api\webSite.js
 * @Description: 接口文件
 */
import request from "@/request/requestHigh";
// const urls = {
//   getOrderNum:"/api/phoneOrder/getOrderNum",
//   getAllNews: "/api/publicsrc/searchAllNews",
//   searchOthers: "/api/publicsrc/searchOthersOne",
//   searchFooter: "/api/publicsrc/searchFooterOne",
//   searchNewsById: "/api/publicsrc/searchNewsById",
//   searchStrategy: "/api/publicsrc/searchStrategy",
//   searchGameData: "/api/publicsrc/searchGameData",
//   searchHeadTitles: "/api/publicsrc/searchHeadTitles",
//   getContactInfo: "/api/publicsrc/searchAllAtlas",
//   getActivityImg: "/api/publicsrc/searchThreeNews",
//   getDownloadUrl: "/api/publicsrc/searchDownloadUrl",
//   uploadFile:"/api/oss/v1/upload",
//   addUploadFile: "/api/image/v1/upload",
//   getUploadImages: "/api/image/v1/query",
//   getCopywriting: "/api/image/v1/queryCopywriting",  
//   setOcpcAccess: "/api/ocpc/access",
//   setDownload: "/api/statistics/download",
//   loadSmsCode: "/api/sms/loadSmsCode",

// };


const urls = {

  getAllNews: "/api/publicsrc/searchAllNews",

  searchNewsById: "/api/publicsrc/searchNewsById",
  searchHeadTitles: "/api/publicsrc/searchHeadTitles",
  searchGameData: "/api/publicsrc/searchGameData",
  searchLatestNews: "/api/publicsrc/searchLatestNews",
  getActivityImg: "/api/publicsrc/searchThreeNews",
  searchOthers: "/api/publicsrc/searchOthersOne",
  searchFooter: "/api/publicsrc/searchFooterOne",


};

const webSite = {

  getAllNews: (newsType) => {
    return request(
      { url: urls.getAllNews,
         method: "get",
         params: {
          "newsType": newsType,
      }
      
       });
  },


  searchNewsById: (params) => {
    return request({ url: urls.searchNewsById, method: "post", data: { ...params } });
  },


  searchGameData: (gameDataType) => {
    return request(
      { url: urls.searchGameData,
         method: "get",
         params: {
          "gameDataType": gameDataType,
      }

       });
  },

  searchLatestNews: (newsType) => {
    return request(
      { url: urls.searchLatestNews,
         method: "get",
         params: {
          "newsType": newsType,
      }
      

       });
  },
  getActivityImg: () => {
    return request({ url: urls.getActivityImg, method: "get" });
  },

  searchOthers: (params) => {
    return request({ url: urls.searchOthers, method: "post", data: { ...params } });
  },

  searchFooter: (params) => {
    return request({ url: urls.searchFooter, method: "post", data: { ...params } });
  },

  searchHeadTitles: () => {
    return request({ url: urls.searchHeadTitles, method: "get" });
  },




};


export default webSite;
